module.exports = __webpack_public_path__ + "img/XOjiangheizhurou.8c8239a1.jpg";